import { Control, Controller } from "react-hook-form";
import { NewCustomer, UpdateCustomer } from "@vy/types";
import { FC } from "react";
import { TextField } from "@mui/material";
import { isNotNullOrUndefined } from "@vy/utils";

interface MarketplaceIdTextInputProps {
    control: Control<NewCustomer | UpdateCustomer>
}

export const MarketplaceIdTextInput: FC<MarketplaceIdTextInputProps> = ({ control }) => (
    <Controller
        control={control}
        name="settings.cloudProviderSettings.cloudProviderMarketplaceId"
        render={({ field, fieldState }) => (
            <TextField
                {...field}
                fullWidth
                label="Account Marketplace ID"
                helperText={fieldState.error?.message}
                error={isNotNullOrUndefined(fieldState.error)}
            />
        )}
    />
)
